<ejs-dialog id="ejDialogSettings" #ejDialogSettings showCloseIcon='true' cssClass="fn-settings-dialog"
  header='Settings' (beforeClose)="onDialogClose($event)" width="1000" [visible]="isVisible"
  [animationSettings]='animationSettings' [target]="dialogDragTarget" [allowDragging]='allowDialogDragging'
  [enableResize]='false' isModal="true">
  <div class="setting-page">

    <!-- ============================================================ RAIL -->
    <div class="side-1" id="side-1">
      <div class="link-main">
        <div class="st-rail-label">Settings</div>
        <ul>
          <li>
            <a href="javascript:void(0)" class="profile st-tab" [class.is-active]="componentName == 'profile'"
              (click)="onChangeComponent('profile')">
              <span class="material-icons md-24 iconBlue menuIcon">person</span>
              <span class="st-tab-text">Profile</span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" class="appearance st-tab" [class.is-active]="componentName == 'appearance'"
              (click)="onChangeComponent('appearance')">
              <span class="material-icons md-24 iconBlue menuIcon">palette</span>
              <span class="st-tab-text">Appearance</span>
            </a>
          </li>
          <li *ngIf="aiTabVisible">
            <a href="javascript:void(0)" class="aifeatures st-tab" [class.is-active]="componentName == 'aifeatures'"
              (click)="onChangeComponent('aifeatures')">
              <span class="material-icons md-24 iconBlue menuIcon">auto_awesome</span>
              <span class="st-tab-text">AI Features</span>
            </a>
          </li>
          <li *ngIf="user.isGroupAdmin">
            <a href="javascript:void(0)" class="branding st-tab" [class.is-active]="componentName == 'branding'"
              (click)="onChangeComponent('branding')">
              <span class="material-icons md-24 iconBlue menuIcon">business</span>
              <span class="st-tab-text">Branding</span>
            </a>
          </li>
          <li *ngIf="user.isGroupAdmin">
            <a href="javascript:void(0)" class="team st-tab" [class.is-active]="componentName == 'team'"
              (click)="onChangeComponent('team')">
              <span class="material-icons md-24 iconBlue menuIcon">groups</span>
              <span class="st-tab-text">Team</span>
            </a>
          </li>
          <li *ngIf="user.isGroupAdmin">
            <a href="javascript:void(0)" class="notifications st-tab" [class.is-active]="componentName == 'notification'"
              (click)="onChangeComponent('notification')">
              <span class="material-icons md-24 iconBlue menuIcon">notifications</span>
              <span class="st-tab-text">Notifications</span>
            </a>
          </li>
          <li *ngIf="user.isGroupAdmin && showCaseManagementTab">
            <a href="javascript:void(0)" class="notifications st-tab"
              [class.is-active]="componentName == 'casemanagement'" (click)="onChangeComponent('casemanagement')">
              <span class="material-icons md-24 iconBlue menuIcon">home_repair_service</span>
              <span class="st-tab-text">Case Management</span>
            </a>
          </li>
          <!-- <li *ngIf="isGroupAdmin">
            <a href="javascript:void(0)" class="notifications" (click)="onChangeComponent('assetmanagement')">
              <span class="material-icons md-24 iconBlue menuIcon">app_shortcut</span>Asset Management</a>
          </li> -->
        </ul>
      </div>
    </div>

    <!-- ============================================================ PANE -->
    <div class="main-content" id="main-content">
      <app-profile-setting *ngIf="this.componentName == 'profile'" #componentProfileSettings></app-profile-setting>
      <app-appearance-setting *ngIf="this.componentName == 'appearance'"></app-appearance-setting>
      <app-ai-feature-setting *ngIf="aiTabVisible && this.componentName == 'aifeatures'"></app-ai-feature-setting>
      <app-branding-setting #componentBranding [isComponentVisible]="this.componentName == 'branding'" ></app-branding-setting>
      <app-team-setting *ngIf="this.componentName == 'team'"></app-team-setting>
      <app-notifications-setting *ngIf="this.componentName == 'notification'"></app-notifications-setting>
      <app-case-management *ngIf="showCaseManagementTab && this.componentName == 'casemanagement'"
        #componentCaseManagement></app-case-management>
      <app-asset-management *ngIf="this.componentName == 'assetmanagement'"></app-asset-management>
    </div>
  </div>
</ejs-dialog>
